import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import Button from '../../../Button';
import { ErrorMessage } from '../../../Typography';

interface IImportDialogProps {
  handleImportProps: (code: string) => void;
}

const ImportDialog = (props: IImportDialogProps) => {
  const [open, setOpen] = React.useState(false);
  const [code, setCode] = React.useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const cleanCode = (): string => {
    const split = code.split('(');
    if (split.length > 1) {
      const split2 = split[1].split(')');
      if (split2.length > 0) {
        return split2[0];
      }
    }
    return '';
  };

  const onImportClick = () => {
    props.handleImportProps(cleanCode());
    handleClose();
  };

  const canParseCode = () => {
    const cleanedCode = cleanCode();
    try {
      return JSON.parse(cleanedCode);
    } catch (e) {
      return undefined;
    }
  };

  const parsedCode = canParseCode();

  return (
    <div>
      <Button
        colorOverride={'#6277E2'}
        size='small'
        secondary
        onClick={() => handleClickOpen()}
      >
        Import
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby='form-dialog-title'>
        <DialogTitle id='form-dialog-title'>Import</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To import widget settings, please paste your widget script code here, including the <script></script> tags.
          </DialogContentText>
          {code && !parsedCode && (
            <ErrorMessage>
              Could not parse code. Please check that you have pasted correctly.
            </ErrorMessage>
          )}
          <TextField
            value={code}
            autoFocus
            margin='dense'
            id='name'
            label='Code'
            fullWidth
            onChange={(e) => setCode(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            colorOverride={'#6277E2'}
            size='small'
            secondary
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
          <Button
            disabled={!parsedCode}
            colorOverride={'#6277E2'}
            size='small'
            secondary
            onClick={() => onImportClick()}
          >
            Import
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ImportDialog;
